<template>
    <div id="erwemaContent">
        <div class="right-top" @click="handleAccountIcon()" v-if="canToggleEwm">
            <div class="erweima"><img th:src="@{imgs/digital-3.png}" src="../../assets/images/digital-3.png" alt="">
            </div>
            <div class="white-bg"></div>
            <div v-if="toggleBg2" class="toggle-bg"></div>
        </div>
        <div v-if="fullscreenLoading" style="position: absolute; width: 100%; height: 100%; z-index: 3;"
            v-loading.lock="fullscreenLoading"></div>
        <!-- <iframe width="266" height="353"
            src="https://login.dg-work.cn/oauth2/auth.htm?response_type=code&client_id=jb-dt_dingoa&redirect_uri=https%3A%2F%2F172.16.1.199%3A4443%2Flogin&scope=get_user_info&authType=QRCODE&embedMode=true"
            frameborder="0"></iframe> -->
        <iframe width="266" height="353" :src="iframeSrc" frameborder="0" v-if="iframeSrc"></iframe>
    </div>
</template>

<script>

export default {
    name: "dingding",
    data() {
        return {
            toggleBg2: false,
            fullscreenLoading: false,
            iframeSrc: null,
            canToggleEwm: this.$envData.canToggleEwm === 'true',
        }
    },
    // destroyed(){
    //     window.removeEventListener("message", function(){
    //         console.log("message事件移除!");
    //     });
    // },
    created() {
        // // 扫码成功后需要在页面中监听扫码结果
        // window.addEventListener('message', async (event) => {
        //     if (!event.data || !event.data.code) return
        //     const url = "/api/user/loginByZzd"
        //     let params = { code: event.data.code }
        //     this.fullscreenLoading = true;
        //     const res = await httpPostSecret(url, params)
        //     this.fullscreenLoading = false;
        //     this.$emit('callback', res)
        //     // this.nextResultStep(res)
        // });

        // 拼接iframe的src
        this.combineIframeSrc()
    },
    methods: {
        setLoading(flag){
            this.fullscreenLoading = flag
        },
        combineIframeSrc() {
            // console.log("48envData:", this.$envData)
            const envData = this.$envData
            // const envData = {
            //     ding_client_id: "blwlsq_dingoa",
            //     ding_redirect_uri: "https%3A%2F%2Fbeilun-sso.tianzhefuture.com%2Fsso%2Flogin",
            //     ding_url: "login-pro.ding.zj.gov.cn"
            // }
            const url = `https://${envData.ding_url}/oauth2/auth.htm?response_type=code&client_id=${envData.ding_client_id}&redirect_uri=${envData.ding_redirect_uri}&scope=get_user_info&authType=QRCODE&embedMode=true`
            this.iframeSrc = url
        },
        handleAccountIcon() {
            this.toggleBg2 = true
            this.$emit('cancel')
            setTimeout(() => {
                this.toggleBg2 = false
            }, 1000)
        },
    }
}
</script>

<style lang="less" scoped>
#erwemaContent {
    height: 380px;
    text-align: center;
    padding-top: 60px;
}

.right-top {
    cursor: pointer;

    .erweima {
        background-color: #65d0a0;
        position: absolute;
        right: 0;
        top: 0;
        width: 56px;
        z-index: 3;
        height: 56px;
        border-radius: 0 12px 0 0;

        img {
            width: 30px;
            height: 30px;
            display: block;
            position: absolute;
            right: 8px;
            top: 8px;
        }
    }
}

.toggle-bg {
    position: absolute;
    animation: mybg 1s linear;
    background-color: #fff;
    opacity: 0.9;
    right: -300px;
    top: -200px;
    z-index: 6;
    transform: rotate(45deg);
    backdrop-filter: blur(30px);
    filter: blur(30px);
}

@keyframes mybg {
    0% {
        width: 0;
        height: 0;
    }

    100% {
        width: 1200px;
        height: 800px;
    }
}

.white-bg {
    width: 0;
    height: 0;
    border-left: 56px solid #fff;
    border-top: 56px solid transparent;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 4;
    transform-origin: left;
}
</style>